import script from "./main.vue?vue&type=script&setup=true&lang=ts"
export * from "./main.vue?vue&type=script&setup=true&lang=ts"

import "./main.vue?vue&type=style&index=0&id=70dde76c&lang=less"

const __exports__ = script;

export default __exports__